import React from 'react';
import { Mail, MapPin, ArrowUp } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const quickLinks = [
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Process', href: '#process' },
    { name: 'Technologies', href: '#technologies' },
    { name: 'Industries', href: '#industries' },
    { name: 'Contact', href: '#contact' }
  ];

  const services = [
    'Software Development',
    'Data Engineering',
    'Cloud Operations',
    'DevOps Services',
    'Cloud Management'
  ];

  const industries = [
    'Finance and Banking',
    'Healthcare',
    'Supply Chain',
    'Retail and E-commerce',
    'Media & Marketing',
    'Non-Profit Organisation'
  ];

  return (
    <>
      <footer className="bg-secondary-900 text-white relative">
        {/* Main Footer Content */}
        <div className="container-custom py-16">
          <div className="grid lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="lg:col-span-1">
              <div className="flex items-center space-x-3 mb-6">
                <img 
                  src="/Logo Icon 1.png" 
                  alt="Scale My Cloud" 
                  className="h-10 w-10"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
                <span className="text-2xl font-bold">Scale My Cloud</span>
              </div>
              <p className="text-secondary-300 mb-6 leading-relaxed">
                Cutting-edge software development, DevOps, and cloud operations enterprise 
                based in the UK. Empowering businesses to scale efficiently and securely.
              </p>
              {/* Contact Info */}
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <Mail className="w-5 h-5 text-primary-400" />
                  <span className="text-secondary-300">info@scalemycloud.com</span>
                </div>
                <div className="flex items-center space-x-3">
                  <MapPin className="w-5 h-5 text-primary-400" />
                  <span className="text-secondary-300">United Kingdom</span>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
              <ul className="space-y-3">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <button
                      onClick={() => scrollToSection(link.href)}
                      className="text-secondary-300 hover:text-primary-400 transition-colors duration-200"
                    >
                      {link.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div>
              <h3 className="text-lg font-semibold mb-6">Services</h3>
              <ul className="space-y-3">
                {services.map((service, index) => (
                  <li key={index} className="text-secondary-300 text-sm">
                    {service}
                  </li>
                ))}
              </ul>
            </div>

            {/* Industries */}
            <div>
              <h3 className="text-lg font-semibold mb-6">Industries</h3>
              <ul className="space-y-3">
                {industries.map((industry, index) => (
                  <li key={index} className="text-secondary-300 text-sm">
                    {industry}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="bg-secondary-900 border-t border-secondary-800">
          <div className="container-custom py-6">
            <div className="flex flex-col md:flex-row items-center justify-between">
              <div className="text-secondary-400 text-sm mb-4 md:mb-0">
                © {currentYear} Scale My Cloud. All rights reserved.
              </div>
              <div className="flex items-center space-x-6">
                <div className="hidden md:flex items-center space-x-6 text-secondary-400 text-sm">
                  <button className="hover:text-primary-400 transition-colors duration-200">
                    Privacy Policy
                  </button>
                  <button className="hover:text-primary-400 transition-colors duration-200">
                    Terms of Service
                  </button>
                  <button className="hover:text-primary-400 transition-colors duration-200">
                    Cookie Policy
                  </button>
                </div>
                
                {/* Desktop Scroll to Top Button */}
                <button
                  onClick={scrollToTop}
                  className="p-2 bg-primary-600 hover:bg-primary-700 rounded-lg transition-colors duration-200 hidden md:block"
                  aria-label="Scroll to top"
                >
                  <ArrowUp className="w-5 h-5 text-white" />
                </button>
              </div>
            </div>
            {/* Mobile Legal Links */}
            <div className="md:hidden mt-4 flex flex-wrap justify-center text-secondary-400 text-sm">
              <div className="flex space-x-6">
                <button className="hover:text-primary-400 transition-colors duration-200">
                  Privacy Policy
                </button>
                <button className="hover:text-primary-400 transition-colors duration-200">
                  Terms of Service
                </button>
                <button className="hover:text-primary-400 transition-colors duration-200">
                  Cookie Policy
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>
      
      {/* Fixed Scroll to Top Button for Mobile */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-6 right-6 z-50 p-3 bg-primary-600 hover:bg-primary-700 rounded-full shadow-lg transition-colors duration-200 md:hidden"
        aria-label="Scroll to top"
      >
        <ArrowUp className="w-6 h-6 text-white" />
      </button>
    </>
  );
};

export default Footer;
